//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../no/SelectObject.js";
import "../no/SelectObject.js";
let d=[[[0,"FaceInterferenceType",1,0],[1,"FirstBody",0,"SelectObject",0],[0,"InterferenceType",1,0],[1,"SecondBody",0,"SelectObject",0]],[[[],"PerformCheck",{R_:{result:''}},0,0],[[],"HighlightNextPair",{R_:{morePairs:''}},0,0],[["nObjects"],"GetInterferenceResults",{R_:{results:"NXObject[]"}},0,0],[[],"Reset",{},0,0]],[]];
SPLM.GeometricAnalysis.SimpleInterference = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.SimpleInterference";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.SimpleInterference.InterferenceMethod = Object.freeze({
    "InterferingFaces" : "InterferingFaces", "InterferenceSolid" : "InterferenceSolid"});

SPLM.GeometricAnalysis.SimpleInterference.FaceInterferenceMethod = Object.freeze({
    "FirstPairOnly" : "FirstPairOnly", "AllPairs" : "AllPairs"});

SPLM.GeometricAnalysis.SimpleInterference.Result = Object.freeze({
    "NoInterference" : "NoInterference", "OnlyEdgesOrFacesInterfere" : "OnlyEdgesOrFacesInterfere", "InterferenceExists" : "InterferenceExists", "CanNotPerformCheck" : "CanNotPerformCheck"});

export default SPLM;